import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export const deleteConversation = (conversationId: string): Promise<void> => {
  return axios.delete(`/chatbot/conversations/${conversationId}`);
};

type UseDeleteConversationOptions = {
  config?: MutationConfig<typeof deleteConversation>;
};

export const useDeleteConversation = ({ config }: UseDeleteConversationOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Conversation deleted successfully',
      });
    },
    ...config,
    mutationFn: deleteConversation,
  });
};
